import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "spinner-border",
    role: "status",
    style: _normalizeStyle({ 
      'width': _ctx.size, 
      'height': _ctx.size, 
      'font-size': _ctx.thickness, 
      'color': _ctx.color 
    })
  }, _hoisted_2, 4))
}